import React from 'react';
import { State } from './stores/admin'; // Import the type of your state

export const FormContext = React.createContext<{
    formState: State;
    dispatch: React.Dispatch<any>;} | undefined>(undefined);